import { useNavigate } from 'react-router-dom'

import OutOfStockIcon from '../../../assets/images/icons/out-of-stock-icon.svg?react'
import type { OutOfStock } from '../../../store/types/dashboard'
import Mixpanel from '../../../utils/mixpanel/Mixpanel'
import { SpaURL } from '../../../utils/url/spa-url'

type OutOfStockProps = {
  outOfStock: OutOfStock | undefined
  company?: any
  view?: string
}

function DashboardOutOfStock({
  outOfStock,
  company,
  view,
}: OutOfStockProps): JSX.Element {
  const navigate = useNavigate()

  const url = new SpaURL(`/products`)
  url.searchParams.append('page', '1')
  url.searchParams.append('limit', '10')
  url.searchParams.append('orderBy', 'name')
  url.searchParams.append('orderDirection', 'asc')
  url.searchParams.append('company_filter_operator', 'and')
  url.searchParams.append('company', '')

  const sendEvent = (event: string): void => {
    Mixpanel.track(event, {
      page: view,
      section: 'Out of Stock Card',
    })
  }

  const onMyStoreClick = () => {
    sendEvent('My Store Clicked')
    url.searchParams.delete('company')
    url.searchParams.delete('company_filter_operator')
    url.searchParams.set('my_stock', '0')
    navigate(url.toString())
  }

  const onCompetitorsClick = () => {
    if (company.has_tracker) {
      sendEvent('Competitors Clicked')
      url.searchParams.delete('filter_stock')
      url.searchParams.delete('company')
      url.searchParams.delete('company_filter_operator')
      url.searchParams.set('competitor_stock', '0')
      navigate(url.toString())
    }
  }

  return (
    <div className="flex container mx-auto px-4 py-5 lg:p-6 flex-col justify-between sm:col-span-3 self-start border border-solid border-gray-200 rounded-lg shadow">
      <div className="flex flex-row sm:flex-col xl:flex-row gap-2 items-center whitespace-nowrap">
        <div className="flex">
          <OutOfStockIcon />
        </div>

        <span className="font-medium text-lg text-gray-900">Out of Stock</span>
      </div>
      <div className="flex flex-col whitespace-nowrap mt-8">
        <div className="flex flex-row justify-between pb-3 ">
          <button
            type="button"
            onClick={onMyStoreClick}
            className="flex flex-row items-center"
          >
            <span className="font-medium text-base text-gray-900">
              My Store
            </span>
          </button>
          <button type="button" onClick={onMyStoreClick}>
            <span className="font-normal text-base text-gray-500">
              {outOfStock?.my_store} Products
            </span>
          </button>
        </div>

        <div className="flex flex-row justify-between pb-3">
          <button
            type="button"
            onClick={onCompetitorsClick}
            className="flex flex-row items-center"
          >
            <span className="font-medium text-base text-gray-900">
              Competitors
            </span>
          </button>
          <button type="button" onClick={onCompetitorsClick}>
            <span className="font-normal text-base text-red-100">
              {outOfStock?.competitors} Products
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default DashboardOutOfStock
